// import { faHouse, faBookOpen, faUser, faBookmark, faUserGroup, faDownload, faLaptopCode, faHome } from '@fortawesome/free-solid-svg-icons';
import { faUser, faBookmark, faUserGroup, faHome } from '@fortawesome/free-solid-svg-icons';

export const navigation = [
    // { name: 'Learning Hub', route: '/learning-hub', icon: faHouse, location: ['NavBar', 'BottomBar'] },
    // { name: 'My Learning', route: '/my-learning', icon: faBookOpen, location: ['NavBar', 'BottomBar'] },
    { name: 'Home', route: '/', icon: faHome, location: ['SlideOver'] },
    { name: 'Profile', route: '/my-profile/user', icon: faUser, location: ['SlideOver'] },
    // { name: 'Bookmarks', route: '/bookmarks', icon: faBookmark, location: ['SlideOver'] },
    // { name: 'Refer', icon: faUserGroup, location: ['SlideOver'] },
    // { name: 'Download CV', icon: faDownload, location: ['SlideOver'] },
    // { name: 'Download Certificate', icon: faDownload, location: ['SlideOver'] },
    // { name: 'About Course', route: '/about-course', icon: faLaptopCode, location: ['SlideOver'] },
];